import React from 'react';
import { icons } from '@/Icons';
import { SideNavItemProps } from '../components/SideNavItem/SideNavItem';

const SKYLINE_TRADER_ID = process.env.NEXT_PUBLIC_GAME_SKYLINE_TRADER_ID;

export const data: SideNavItemProps[] = [
	{
		title: 'Home',
		link: '/',
		icon: <icons.home />,
	},
	{
		title: 'Favorites',
		link: '/casino/category/favorites',
		icon: <icons.favorites />,
		authRequired: true,
	},
	...(SKYLINE_TRADER_ID
		? [
				{
					title: 'Skyline Trader™',
					link: `/casino/play-game/${SKYLINE_TRADER_ID}`,
					icon: <icons.fantasy />,
				},
			]
		: []),
];

export const casinoData: SideNavItemProps[] = [
	{
		title: 'Otherworld Originals',
		link: '/casino/category/otherworld-originals',
		icon: <icons.otherworldoriginals />,
	},

	{
		title: 'Trending',
		link: '',
		icon: <icons.trending />,
	},
	{
		title: 'Casino Classics',
		link: '',
		icon: <icons.casinoclassics />,
	},
	{
		title: 'Slots',
		link: '',
		icon: <icons.slots />,
	},
	{
		title: 'Live Casino',
		link: '',
		icon: <icons.livecasino />,
	},
	{
		title: 'Blackjack',
		link: '',
		icon: <icons.blackjack />,
	},
	{
		title: 'Roulette',
		link: '',
		icon: <icons.roulette />,
	},
	{
		title: 'Game Shows',
		link: '',
		icon: <icons.gameshows />,
	},
	{
		title: 'Baccarat',
		link: '',
		icon: <icons.baccarat />,
	},
	{
		title: 'Providers',
		link: '',
		icon: <icons.providers />,
	},
];

export const otherData: SideNavItemProps[] = [
	{
		title: 'Affiliates',
		link: 'https://www.otherworldaffiliates.com',
		icon: <icons.affiliates />,
	},
	{
		title: 'Help Center',
		link: '/help-center',
		icon: <icons.helpcenter />,
	},
];
